import { Component } from '@angular/core';
import { MenuModel } from '@app/core/models';
import { CommonService } from '@app/core/services';
import { MenuState } from '@app/core/store';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  showHeader = true;

  @Select(MenuState.getMenu)
  menuList$: Observable<Array<MenuModel>>;

  constructor(private commonService: CommonService) {}

  changeOfRoutes(): void {
    this.commonService.changeOfRoutes();
  }
}
